import { FIFTEEN_MINUTES } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { PatientService } from 'services/patient';
import { type PatientRecord } from 'types/patient';

const POLLING_INTERVAL_MS = 3000;

interface UseFetchActivePatientRecordOptions {
  polling?: boolean;
}

export const useFetchActivePatientRecord = (
  patientId: string,
  { polling = false }: UseFetchActivePatientRecordOptions = {}
): UseQueryResult<PatientRecord | null> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_PATIENT_ACTIVE_RECORD, patientId],
    queryFn: async (): Promise<PatientRecord | null> => {
      const response = await PatientService.getActiveRecord(patientId);
      if (!response.data || typeof response.data === 'string') return null;
      return response.data;
    },
    enabled: !!patientId,
    staleTime: FIFTEEN_MINUTES,
    refetchInterval: polling
      ? (query): number | false => (query.state.data?.code ? false : POLLING_INTERVAL_MS)
      : false,
  });
